<template>
  <section class="anchor rynit" :id="$t('header.nav[6].link')">
    <div class="container">
      <h2 class="rynit__title" v-html="$t('home.rynit.title')"></h2>
      <h3 class="rynit__subtitle" v-html="$t('home.rynit.subtitle')"></h3>
      <div class="row">
        <div class="col-x-lg-4 col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <div class="rynit__item">
            <h5
              class="rynit__item-title"
              v-html="$t('home.rynit.item_1.title')"
            ></h5>
            <div class="rynit__item-image">
              <img src="~@/assets/img/home/rynit/item-1.png" alt="" />
            </div>
            <p
              class="rynit__item-text"
              v-html="$t('home.rynit.item_1.text')"
            ></p>
            <router-link
              @click.native="mainRinit1()"
              :to="$t('home.rynit.item_1.button.link')"
              class="rynit__item-btn"
            >
              {{ $t("home.rynit.item_1.button.title") }}
            </router-link>
          </div>
        </div>
        <div class="col-x-lg-4 col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <div class="rynit__item">
            <h5
              class="rynit__item-title"
              v-html="$t('home.rynit.item_2.title')"
            ></h5>
            <div class="rynit__item-image">
              <img src="~@/assets/img/home/rynit/item-2.png" alt="" />
            </div>
            <p
              class="rynit__item-text"
              v-html="$t('home.rynit.item_2.text')"
            ></p>
            <router-link
              @click.native="mainRinit2()"
              :to="$t('home.rynit.item_2.button.link')"
              class="rynit__item-btn"
            >
              {{ $t("home.rynit.item_2.button.title") }}
            </router-link>
          </div>
        </div>
        <div class="col-x-lg-4 col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <div class="rynit__item">
            <h5
              class="rynit__item-title"
              v-html="$t('home.rynit.item_3.title')"
            ></h5>
            <div class="rynit__item-image">
              <img src="~@/assets/img/home/rynit/item-3.png" alt="" />
            </div>
            <p
              class="rynit__item-text"
              v-html="$t('home.rynit.item_3.text')"
            ></p>
            <router-link
              @click.native="mainRinit3()"
              :to="$t('home.rynit.item_3.button.link')"
              class="rynit__item-btn"
            >
              {{ $t("home.rynit.item_3.button.title") }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Rynit",
  methods: {
    mainRinit1() {
      // eslint-disable-next-line no-undef
      gtag("event", "click", { event_category: "main_rinit_1" });
    },
    mainRinit2() {
      // eslint-disable-next-line no-undef
      gtag("event", "click", { event_category: "main_rinit_2" });
    },
    mainRinit3() {
      // eslint-disable-next-line no-undef
      gtag("event", "click", { event_category: "main_rinit_3" });
    }
  }
};
</script>
